import React from "react";
import ScrollableModal from "../../../../../components/Universal/ScrollableModal.component";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import FormInput from "../../../../../components/Universal/FormInput.component";
import { Formik } from "formik";
import CustomBill from "../../../../../components/Universal/CustomBill.component";
import VendorPaymentValidation from "../../../../../components/PagesComponents/Financial/CashOutFlow/AcademicEx/MaterialAndResources/VendorPaymentValidation.component";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";
import DatePicker from "../../../../../components/Universal/DatePicker.component";
import SearchIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import "../../../../../styles/Pages/Financial/CashOutFlow/AcademicEx/MaterialAndResources.style.css";
import AcademicUniversalTable from "../../../../../components/Universal/Tables/AcademicUniversalTable.component";
import UniversalTable from "../../../../../components/Universal/Tables/UniversalTable.component";

const Body = ({
  teacherList,
  teacherTableHeaders,
  eventHistoryData,
  columns,
  confirmedByOptions,
  paymentModes,
}) => {
  const [isReceiptOpen, setIsReceiptOpen] = React.useState(false);
  const [checkedItems, setCheckedItems] = React.useState({});
  const [selectedData, setSelectedData] = React.useState([]);
  const [submittedValues, setSubmittedValues] = React.useState(null);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [showHistory, setShowHistory] = React.useState(false);

  const handleSelectAll = () => {
    const allSelected = Object.keys(checkedItems).length === teacherList.length;
    if (allSelected) {
      setCheckedItems({});
      setSelectedData([]);
    } else {
      const newChecked = {};
      const newSelected = [];
      teacherList.forEach((item) => {
        newChecked[item.itemCode] = true;
        newSelected.push(item);
      });
      setCheckedItems(newChecked);
      setSelectedData(newSelected);
    }
  };

  const handleSingleCheck = (itemCode, item) => {
    const updated = { ...checkedItems };
    const isChecked = !!updated[itemCode];

    if (isChecked) {
      delete updated[itemCode];
      setSelectedData((prev) => prev.filter((d) => d.itemCode !== itemCode));
    } else {
      updated[itemCode] = true;
      setSelectedData((prev) => [...prev, item]);
    }

    setCheckedItems(updated);
  };

  if (showHistory)
    return (
      <section className="ProfessionalDevelopmentSection">
        <ScrollableModal
          isOpen={isReceiptOpen}
          onClose={() => setIsReceiptOpen(!isReceiptOpen)}
        >
          {isReceiptOpen && (
            <CustomBill data={selectedData} vendorInfo={submittedValues} />
          )}
        </ScrollableModal>
        <Helmet>
          <title>All payments history</title>
          <meta
            name="description"
            content="Monitor and analyze cash inflow trends and contributions."
          />
          <meta
            name="keywords"
            content="All payments history, cash outflow, financial dashboard, cash flow analysis, business finance"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
        <PageHeader title={"All payments history"} />
        <div
          style={{
            marginTop: "1rem",
            backgroundColor: "white",
            padding: "2rem",
            borderRadius: "10px",
          }}
          className="HistorySection"
        >
          <div className="history-header mb-1">
            <h3
              style={{
                color: "var(--grayColor)",
                fontWeight: "500",
                marginBottom: "0.5rem",
              }}
            >
              All professional development payment history
            </h3>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="inputs-buttons"
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                className="input"
              >
                <div className="searchInputContainer">
                  <button className="searchBtn">
                    <img src={SearchIcon} alt="Search" />
                  </button>
                  <input
                    type="text"
                    className="pageHeaderInput"
                    placeholder="Search id"
                  />
                </div>
                <DatePicker
                  label=""
                  name="date"
                  setFieldValue={() => {}}
                  placeholder={"Choose a date"}
                  errors={() => {}}
                />
              </div>
              <div style={{ display: "flex", gap: "1rem" }} className="buttons">
                <button
                  style={{
                    backgroundColor: "var(--blueColor1)",
                    borderColor: "var(--blueColor1)",
                  }}
                  onClick={() => setShowHistory(false)}
                  className="actionBtn"
                >
                  Go to professional development
                </button>
                <button className="actionBtn">Download</button>
              </div>
            </div>
          </div>
          <div className="history-table">
            <UniversalTable
              columns={columns}
              data={eventHistoryData}
              maxBodyHeight="340px"
              footer={
                <div className="Amount-Indicators">
                  <div className="indicator-group">
                    <span className="indicator-box filled-orange">
                      Total count: <span className="text-white">236</span>
                    </span>

                    <span className="indicator-box outlined-orange">
                      Due amount:{" "}
                      <span className="text-orange">₹ 2,60,560</span>
                    </span>
                  </div>

                  <div className="indicator-group">
                    <span className="indicator-box outlined-blue">
                      Total amounts:{" "}
                      <span className="text-blue-light">₹ 2,60,560</span>
                    </span>

                    <span className="indicator-box filled-blue">
                      Paid amount:{" "}
                      <span className="text-white">₹ 2,60,560</span>
                    </span>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </section>
    );

  return (
    <section className="AcademicEventSection">
      <ScrollableModal
        isOpen={isReceiptOpen}
        onClose={() => setIsReceiptOpen(!isReceiptOpen)}
      >
        {isReceiptOpen && (
          <CustomBill data={selectedData} vendorInfo={submittedValues} />
        )}
      </ScrollableModal>
      <Helmet>
        <title>Professional development</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="Professional development,cash outflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader title={"Professional development"} />
      <div className="MaterialAndResourceContaienr">
        <div className="left">
          <AcademicUniversalTable
            title="Name of all teachers & associates"
            headers={teacherTableHeaders}
            data={teacherList}
            showCheckbox={true}
            checkedItems={checkedItems}
            onSelectAll={handleSelectAll}
            onRowSelect={handleSingleCheck}
          />
        </div>
        <div className="right">
          <div className="content-header">
            <h3>Confirmation of Payment</h3>
            <button
              onClick={() => setShowHistory(true)}
              className="blueActionBtnLight"
            >
              All Payments History
            </button>
          </div>

          {showSuccess ? (
            <div className="billSuccess">
              <h2>You have confirm payment successfully</h2>
              <p>Receipt ID: 23456789012</p>
              <h4 onClick={() => setIsReceiptOpen(true)}>
                Receipt <BsBoxArrowRight />
              </h4>
              <button
                onClick={() => setShowSuccess(false)}
                className="actionBtn"
              >
                Okay
              </button>
            </div>
          ) : (
            selectedData.length > 0 && (
              <>
                <div className="bill-table-container">
                  <table className="bill-table">
                    <thead>
                      <tr>
                        <th>Name({selectedData.length})</th>
                        <th>id</th>
                        <th>Work status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {console.log("Selected Data:", selectedData)}
                      {selectedData.map((item) => (
                        <tr key={item.itemCode}>
                          <td>{item?.name}</td>
                          <td>{item?.itemCode}</td>
                          <td className="reporter">
                            {item?.designation}
                            <br />
                            {item?.subject}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="formContaienr">
                  <Formik
                    initialValues={{
                      vendorName: "",
                      vendorContact: "",
                      paidAmount: "",
                      confirmedBy: "",
                      paymentMode: "",
                    }}
                    validationSchema={VendorPaymentValidation}
                    onSubmit={(values) => {
                      console.log("Form Submitted:", values);
                      setSubmittedValues(values);
                      setShowSuccess(true);
                    }}
                  >
                    {({
                      setFieldValue,
                      handleSubmit,
                      touched,
                      errors,
                      setTouched,
                    }) => (
                      <form
                        onSubmit={handleSubmit}
                        className="vendorPaymentForm"
                      >
                        <div className="vendorPaymentFormInputs">
                          <FormInput
                            label="Vendor name"
                            type="text"
                            name="vendorName"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter vendor name"
                            setFieldValue={(e) =>
                              setFieldValue("vendorName", e.target.value)
                            }
                          />

                          <FormInput
                            label="Vendor contact"
                            type="text"
                            name="vendorContact"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter vendor contact number"
                            setFieldValue={(e) =>
                              setFieldValue("vendorContact", e.target.value)
                            }
                          />

                          <FormInput
                            label="Paid amount (INR)"
                            type="number"
                            name="paidAmount"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter paid amount"
                            setFieldValue={(e) =>
                              setFieldValue("paidAmount", e.target.value)
                            }
                          />

                          <DropDownInput
                            name="confirmedBy"
                            label="Confirmed by"
                            placeholder="Choose confirmed by"
                            suggestionList={confirmedByOptions}
                            setFieldValue={(val) =>
                              setFieldValue("confirmedBy", val)
                            }
                            touched={touched}
                            errors={errors}
                            setTouched={(name, isTouched) =>
                              setTouched({ [name]: isTouched })
                            }
                          />

                          <DropDownInput
                            name="paymentMode"
                            label="Payment mode"
                            placeholder="Choose payment mode"
                            suggestionList={paymentModes}
                            setFieldValue={(val) =>
                              setFieldValue("paymentMode", val)
                            }
                            touched={touched}
                            errors={errors}
                            setTouched={(name, isTouched) =>
                              setTouched({ [name]: isTouched })
                            }
                          />
                        </div>

                        <button
                          // onClick={() => setIsReceiptOpen(true)}
                          type="submit"
                          className="confirmPaymentBtn actionBtn"
                        >
                          Confirm payment
                        </button>
                      </form>
                    )}
                  </Formik>
                </div>
              </>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Body;
